export default __webpack_public_path__ + "static/media/ear.b0d4b5e5.svg";